<template>
<section class="latest-news px-4 py-5% bg-gray-300">
    <div class="max-w-5xl mx-auto">
        <SmoothLoader class="grid relative">
            <div class="flex items-center py-8 vt:py-0">
                <h2 class="headline font-body italic font-bold text-4xl vt:text-6xl text-primary-500 leading-tight" v-html="headline"></h2>
            </div>
            <PostPreview v-for="post in posts" :post="post"></PostPreview>
        </SmoothLoader>
    </div>
</section>
</template>

<script>
import { ref, computed } from 'vue';
import PostPreview from '../Utilities/PostPreview.vue';

export default {
    
    props: ['data'],

    setup(props) {
        return {
            ...props.data
        };
    },

    components: {
        PostPreview
    }

}
</script>